import React, { PropsWithChildren } from 'react'
import {
  ThemeProvider as ThemeProviderSC,
  DefaultTheme,
} from 'styled-components'

const screenSizes = {
  phone: 575,
  tablet: 991,
  largeTablet: 1199,
}

// https://digitalnsw.github.io/nsw-design-system/core/colour/index.html

const theme: DefaultTheme = {
  palette: {
    // brand colors
    nswBrandDark: 'var(--nsw-brand-dark)',
    nswBrandLight: 'var(--nsw-brand-light)',
    nswBrandSupplementary: 'var(--nsw-brand-supplementary)',
    nswBrandAccent: 'var(--nsw-brand-accent)',
    //grey colors
    nswPaletteBlack: 'var(--nsw-palette-black)',
    nswPaletteGrey01: 'var(--nsw-palette-grey-01)',
    nswPaletteGrey02: 'var(--nsw-palette-grey-02)',
    nswPaletteGrey03: 'var(--nsw-palette-grey-03)',
    nswPaletteGrey04: 'var(--nsw-palette-grey-04)',
    nswPaletteOffWhite: 'var(--nsw-palette-off-white)',
    nswPaletteWhite: 'var(--nsw-palette-white)',
    //text colors
    nswTextDark: 'var(--nsw-text-dark)',
    nswTextLight: 'var(--nsw-text-light)',
    nswFocus: 'var(--nsw-focus)',
    nswTextHoverBg: 'var(--nsw-text-hover-bg)',
    nswTextVisited: 'var(--nsw-text-visited)',
    //status colors
    nswStatusInfoBlue: 'var(--nsw-status-info-blue)',
    nswStatusInfoBlueBg: 'var(--nsw-status-info-blue-bg)',
    nswStatusSuccessGreen: 'var(--nsw-status-success-green)',
    nswStatusSuccessGreenBg: 'var(--nsw-status-success-green-bg)',
    nswStatusWarningOrange: 'var(--nsw-status-warning-orange)',
    nswStatusWarningOrangeBg: 'var(--nsw-status-warning-orange-bg)',
    nswStatusErrorRed: 'var(--nsw-status-error-red)',
    nswStatusErrorRedBg: 'var(--nsw-status-error-red-bg)',
  },
  font: {
    base: '100%', // == 16px
    body: '1rem',
    heading: '1.5rem',
    subHeading: '1.25rem',
    caption: '0.875rem',
    small: `0.75rem`,
    button: '1.75rem',
    color: {
      menu: 'var(--nsw-text-dark)',
    },
  },
  fontWeight: {
    regular: 400,
    bold: 800,
  },
  unit: 16,
  breakPoints: {
    phone: `max-width: ${screenSizes.phone}px`,
    tablet: `max-width: ${screenSizes.tablet}px`,
    largeTablet: `max-width: ${screenSizes.largeTablet}px`,
  },
  screenSizes,
}

export default function ThemeProvider({
  children,
}: PropsWithChildren<Record<string, unknown>>) {
  return <ThemeProviderSC theme={theme}>{children}</ThemeProviderSC>
}
